
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import ScrollToTop from "@/components/ScrollToTop";

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <section className="max-w-4xl mx-auto px-4 py-20 mt-16">
        <h1 className="text-4xl font-bold text-primary mb-8">Politique de confidentialité</h1>
        <p className="text-sm text-foreground/60 mb-8">Dernière mise à jour : mai 2025</p>
        
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">1. Données personnelles</h2>
            <p>Les données personnelles collectées via les formulaires ou lors des prises de rendez-vous sont utilisées uniquement pour assurer le bon fonctionnement des services proposés par Meredith Meneora. Elles ne sont en aucun cas revendues ou cédées à des tiers.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">2. Finalités de la collecte</h2>
            <p>Les données peuvent être utilisées pour :</p>
            <ul className="list-disc ml-6 space-y-1 mt-2">
              <li>Gérer les réservations et prises de rendez-vous</li>
              <li>Répondre aux demandes de contact</li>
              <li>Partager des informations utiles en lien avec les accompagnements</li>
              <li>Assurer le suivi administratif et relationnel</li>
            </ul>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">3. Durée de conservation</h2>
            <p>Les données sont conservées pendant la durée strictement nécessaire à la relation professionnelle, et peuvent être supprimées sur simple demande.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">4. Sécurité</h2>
            <p>Les données sont traitées de manière confidentielle et sécurisée. Elles ne sont accessibles qu'à la responsable du site, Meredith Meneora.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">5. Vos droits</h2>
            <p>Conformément à la loi Informatique et Libertés et au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour toute demande, contactez-moi via WhatsApp au 06 07 50 74 12.</p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/">
            <Button variant="outline">← Retour à l'accueil</Button>
          </Link>
        </div>
      </section>
      
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default PolitiqueConfidentialite;
